// extracted by mini-css-extract-plugin
export default {"container":"PageTitle_container__bj+Ti"};